/**
 * A module containing utilities for determining device details.
 * @module abt-utils/device
 */

import _ from 'lodash'
import cookies from './cookies'
import siteConfig from '../abt-core/site-config.json'

/**
 * Gets the view property based on the customer's device size.
 * @returns {string} Returns the view property.
 */
export function getSize () {
  var lookup = {
    s: 'smallView',
    m: 'largeView',
    l: 'largeView'
  }

  return lookup[cookies.get(siteConfig.cookies.rdpCookieName)]
}

/**
 * Determines if the test includes the customer's device size.
 * @param {object} test - The test config to evaluate.
 * @returns {array} Returns an empty array if the test includes the customer's device size,
 * otherwise returns an array containing an error message.
 */
export function validate (test) {
  if (window.foo) console.log(test)
  var allowedSizes = test.deviceSize || ['m', 'l']
  var deviceSize = cookies.get(siteConfig.cookies.rdpCookieName)
  var message = 'device size `' + deviceSize + '` not in [' + allowedSizes.toString() + ']'

  return _.includes(allowedSizes, deviceSize) ? [] : [message]
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/device.js
 ** module id = 10
 ** module chunks = 2 3
 **/